import request from "@/utils/request";
//===============消息服务
let baseUrl = '/message'
// 分页查询
export const postServicePage = (data) => {
  return request({
    url: baseUrl+"/service/page",
    method: "post",
    data,
  });
};
// 不分页查询
export const postServiceList = (data) => {
  return request({
    url: baseUrl+"/service/list",
    method: "post",
    data,
  });
};

// 新增数据
export const postServiceSave = (data) => {
  return request({
    url: baseUrl+"/service/save",
    method: "post",
    data,
  });
};

// 修改数据
export const postServiceUpdate = (data) => {
  return request({
    url: baseUrl+"/service/update",
    method: "post",
    data,
  });
};

// 删除
export const deleteServiceDelete = (params) => {
  return request({
    url: baseUrl+`/service/delete/${params?.id ?? params}`,
    method: "DELETE",
  });
};
// 详情
export const getService = (params) => {
  return request({
    url: baseUrl+`/service/${params?.id ?? params}`,
    method: "get",
  });
};

//===============消息管理
// 分页查询
export const postMessagePage = (data) => {
  return request({
    url: baseUrl+"/message/page",
    method: "post",
    data,
  });
};


// 详情
export const getMessage= (params) => {
  return request({
    url: baseUrl+`/message/${params?.id ?? params}`,
    method: "get",
  });
};

// 推送数据
export const postMessagePushMessage = (data) => {
  return request({
    url: baseUrl+"/message/pushMessage",
    method: "post",
    data,
  });
};

//===============消息配置
// 分页查询
export const postConfigPage = (data) => {
  return request({
    url: baseUrl+"/config/page",
    method: "post",
    data,
  });
};
// 不分页查询
export const postConfigList = (data) => {
  return request({
    url: baseUrl+"/config/list",
    method: "post",
    data,
  });
};

// 新增数据
export const postConfigSave = (data) => {
  return request({
    url: baseUrl+"/config/save",
    method: "post",
    data,
  });
};

// 修改数据
export const postConfigUpdate = (data) => {
  return request({
    url: baseUrl+"/config/update",
    method: "post",
    data,
  });
};

// 删除
export const deleteConfigDelete = (params) => {
  return request({
    url: baseUrl+`/config/delete/${params?.id ?? params}`,
    method: "DELETE",
  });
};
// 详情
export const getConfig = (params) => {
  return request({
    url: baseUrl+`/config/${params?.id ?? params}`,
    method: "get",
  });
};
